import Moment from "moment"; // we need it he as we use isMoment

export default function isMoment(value:any):boolean {

    return Moment.isMoment(value)

}